import ReactMarkdown from "react-markdown";
import remarkDirective from "remark-directive";
import remarkGfm from "remark-gfm";
import {cn} from "@/lib/utils.ts";
import remarkDireDawnDirectives from "@/components/markdown/remarkDireDawnDirectives.ts";

export default function MarkdownContent({markdown, className}: {
    markdown: string;
    className?: string;
}) {
    return (
        <div className={cn(
            "leading-relaxed",
            "[&_p:last-child]:mb-0",
            "[&_ul]:my-3 [&_ul]:ml-5 [&_ul]:list-disc",
            "[&_ol]:my-3 [&_ol]:ml-5 [&_ol]:list-decimal",
            "[&_li]:my-1",
            "[&_h1]:my-4 [&_h1]:text-2xl [&_h1]:font-bold",
            "[&_h2]:my-3 [&_h2]:text-xl [&_h2]:font-bold",
            "[&_h3]:my-3 [&_h3]:text-lg [&_h3]:font-semibold",
            "[&_h4]:my-2 [&_h4]:font-semibold",
            "[&_h5]:my-2 [&_h5]:font-semibold",
            "[&_blockquote]:my-3 [&_blockquote]:border-l-4 [&_blockquote]:border-current/30 [&_blockquote]:pl-3",
            "[&_table]:my-4 [&_table]:w-full [&_table]:border-collapse",
            "[&_th]:border [&_th]:border-current/40 [&_th]:bg-black/5 [&_th]:p-1 [&_th]:font-bold",
            "[&_td]:border [&_td]:border-current/40 [&_td]:p-1",
            "[&_a]:underline [&_a]:underline-offset-2",
            className,
        )}>
            <ReactMarkdown
                skipHtml
                remarkPlugins={[remarkGfm, remarkDirective, remarkDireDawnDirectives]}
            >
                {markdown}
            </ReactMarkdown>
        </div>
    );
}
